import * as Yup from 'yup';

export const CreateStoreFormValidationSchema = Yup.object({
  operationLocationId: Yup.string()
    .trim()
    .required('Operation Location is required'),
  companyId: Yup.string().trim().required('Company is required'),
  name: Yup.string()
    .trim()
    .required('Branch Name is required')
    .max(80, 'Max length is 80 characters'),
  storeCode: Yup.string().trim().required('Store code is Required'),
  email: Yup.string()
    .trim()
    .email('Invalid email format')
    .required('Email is required'),
  phoneNumber: Yup.string()
    .trim()
    // .matches(/^\d{10}$/, 'Phone number must be 10 digits')
    .required('Required'),
  countryCode: Yup.string()
    .trim()
    .required('Country code is required')
    .max(7, 'Max length is 7 characters'),
  addressLine1: Yup.string()
    .trim()
    .required('Address is required')
    .max(100, 'Max length is 100 characters'),
  addressLine2: Yup.string().max(100, 'Max length is 100 characters'),
  landmarks: Yup.string()
    .trim()
    .required('landmark is required')
    .max(80, 'Max length is 80 characters'),
  city: Yup.string()
    .trim()
    .required('City is required')
    .max(40, 'Max length is 40 characters'),
  state: Yup.string()
    .trim()
    .required('State is required')
    .max(40, 'Max length is 40 characters'),
  country: Yup.string()
    .trim()
    .required('Country is required')
    .max(40, 'Max length is 40 characters'),
  pincode: Yup.string()
    .trim()
    .required('Required')
    .matches(/^\d{6}$/, 'Pincode must be 6 digits'),
  status: Yup.string().trim().required('Status is required'),
});
